import { render, staticRenderFns } from "./CPacker.vue?vue&type=template&id=70bc3a85&scoped=true&"
import script from "./CPacker.vue?vue&type=script&lang=js&"
export * from "./CPacker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc3a85",
  null
  
)

export default component.exports